<template>
  <div>
    <a-form
      ref="addForm" :form="form" :disabled="$route.query.titless == '查看'"
      class="detail-form"
    >
      <div class="card-container">
        <div class="card-title subtitle">
          基础信息
        </div>
        <div class="card-content">
          <a-row>
            <a-col :span="12">
              <a-form-item
                label="图标"
                :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }"
              >
                <a-upload
                  :disabled="$route.query.titless == '查看'"
                  list-type="picture-card"
                  class="avatar-uploader"
                  :show-upload-list="true"
                  :before-upload="beforeUpload"
                  :file-list="fileList"
                  :remove="handleRemove"
                  :max-count="1"
                  @preview="handlePreview"
                  @change="handleChange"
                >
                  <img v-if="imgUp && $route.query.title != '添加'" :src="imgUp" alt="avatar">
                  <div v-else>
                    <a-icon :type="loading ? 'loading' : 'plus'" />
                    <div class="ant-upload-text">
                      图标上传
                    </div>
                  </div>
                </a-upload>
                <a-modal
                  :visible="previewVisible" centered :footer="null"
                  @cancel="handleCancel"
                >
                  <img alt="example" style="width: 100%" :src="previewImage">
                </a-modal>
                <div class="upload-tip">
                  <a-icon class="tip-icon" type="info-circle" />图标最多可以上传1张，每张大小不超过10M，格式为png，jpeg，jpg。
                </div>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item
                label="名称"
                v-bind="formItemLayout"
              >
                <a-input
                  v-decorator="[
                    'name',
                    {
                      rules: [
                        {
                          required: true,
                          message: '请填写名称',
                        }
                      ]
                    }
                  ]"
                  :disabled="$route.query.titless == '查看'"
                  placeholder="请填写名称"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item
                label="商品品类"
                v-bind="formItemLayout"
              >
                <a-tree-select
                  v-model="values"
                  :replace-fields="{children:'childList', title:'title', key:'id', value: 'id' }"
                  style="width: 100%"
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                  :tree-data="treeData"
                  placeholder="请选择"
                  allow-clear
                  multiple
                  tree-default-expand-all
                  tree-checkable
                  <<<<<<<
                  h-e-a-d :disabled="$route.query.titless == '查看'"
                  =="====="
                  @change="onChanges"
                >
                  >>>>>> 34d40cbf426381df19b7d3f8fea4b8d0ea539aba
                  >
                </a-tree-select>
              </a-form-item>
            </a-col>
          </a-row>
        </div>

        <div class="card-content mb40 mt40">
          <a-row type="flex" justify="center">
            <a-col
              :span="12" type="flex" align="middle"
              style="text-align:center;"
            >
              <a-button
                v-if="$route.name === 'addGoods'" class="mr8"
                @click="reset"
              >
                重置
              </a-button>
              <a-button v-else class="mr8" @click="back">
                返回
              </a-button>
              <a-button
                v-if="$route.query.titless != '查看'"
                type="primary"
                @click="save"
              >
                保存
              </a-button>
            </a-col>
          </a-row>
        </div>
      </div>
    </a-form>
  </div>
</template>

<script>
import { getBrandInfo, saveBrand, getPostHouseGoodsTypeJsonList } from '@/api/postManagement'
export default {

  data () {
    return {
      form: this.$form.createForm(this, { name: 'addForm' }),
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 17 }
      },
      merchantList: [],
      shopType: '5',
      isRestraint: 1,
      upperShelf: 0,
      downShelf: 0,
      showUpper: false,
      showDown: false,
      fileListGoods: [],
      fileListDetail: [],
      fileList: [],
      imageUrl: '',
      loading: false,
      optionsItem: [],
      labelList: [],
      allLabel: [],
      cityList: [],
      options: [],
      areaContain: [],
      areaNames: [],
      mapDialogObj: {
        visible: false
      },

      previewVisible: false,
      previewImage: '',
      managerId: '',
      estateList: [],
      estateLists: [],
      imgUp: '',
      positionInfo: null,
      treeData: [],
      values: [],
      form: this.$form.createForm(this, { name: 'siteContent' })
    }
  },
  mounted () {
    this.getPosList()
    // this.getPostHouseInfo()
    // if (this.$route.query.title) {
    //   this.getPostHouseInfo()
    // }
    if (this.$route.query.title == '编辑' || this.$route.query.titless == '查看') {
      this.getPostHouseInfo()
    }
  },
  methods: {
    onChanges (value) {

      this.values = value
      // this.form.setFieldsValue({
      //     typeList: value
      //   })
    },
    getPosList () {
      const parems = {

      }
      getPostHouseGoodsTypeJsonList(parems).then(res => {

        this.treeData = res.result
        // this.form.setFieldsValue({
        //   name: res.result.name
        // })
      })
    },
    getPostHouseInfo () {
      const parems = {
        id: this.$route.query.id
      }
      getBrandInfo(parems).then(res => {

        this.imgUp = res.result.icon
        this.values = res.result.typeList
        this.form.setFieldsValue({
          name: res.result.name
        })
      })
    },

    // getPostHouseInfos () {
    //   const parems = {
    //     id: this.$route.query.id
    //   }
    //   getBrandInfo(parems).then(res => {
    //     this.imgUp = res.result.icon
    //     this.values = res.result.typeList
    //     this.form.setFieldsValue({
    //       name: res.result.name
    //     })
    //   })
    // },

    // 图片上传
    handleCancel () {
      this.previewVisible = false
    },
    beforeUpload (file) {
      if (this.fileList.length >= 1) {
        this.$message.error('最多可上传1张图片！')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 10
      const isType = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg'
      if (!isLt2M) {
        this.$message.error('每张图片大小不能超过10M！')
        return false
      }
      if (!isType) {
        this.$message.error('请选择png，jpeg，jpg格式图片上传！')
        return false
      }
      return false
    },
    handlePreview (file) {
      this.previewImage = file.url || file.thumbUrl
      this.previewVisible = true
    },
    handleRemove (file) {
      this.fileList.forEach((item, index) => {
        if (item.uid === file.uid) {
          this.fileList.splice(index, 1)
        }
      })
    },
    loadData (selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      this.getArea(targetOption.id, targetOption.layer + 1, targetOption, true)
    },
    onChange (value) {
      if (value.length <= 1) {
        this.$nextTick(() => {
          this.form.setFieldsValue({
            categoryId: []
          })
        })
      }
    },
    changeShopType () {
      this.form.setFieldsValue({ 'integral': undefined })
    },
    getFlielistGoods (e) {
      this.fileListGoods = e
    },
    getFlielistDetail (e) {
      this.fileListDetail = e
    },
    handleGoods (e) {
      this.fileListGoods = e
    },
    goodsDel (e) {
      this.fileListDetail = e
    },
    handleDetail (e) {
      this.fileListGoods = e
    },
    detailDel (e) {
      this.fileListDetail = e
    },

    loadDataItem (selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      this.getCategory(targetOption.id, 2, targetOption)
    },

    handleChange ({ file, fileList }) {
      if (this.fileList.length === 1) {
        return false
      }
      var formdata = new FormData()
      formdata.append('file', file)
      var config = {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
      this.$httpPost(this.$basePath.uploadImage, formdata, config)
        .then(res => {
          this.imgUp = res.result

          this.$message.success('上传成功！')
          fileList.forEach(item => {
            if (item.uid === file.uid) {
              Object.assign(item, {
                url: res.result
              })
            }
          })
          this.fileList = fileList
        })
    },

    save (e) {
      // var param = JSON.parse(JSON.stringify(this.form.getFieldsValue()))
      // param.icon = this.imgUp
      // param.typeList = this.values
      // if (this.$route.query.title === '编辑') {
      //   param.id = this.$route.query.id
      // }
      // saveBrand(param).then((res) => {
      //   this.$message.success(res.msg)
      //   this.$router.push({
      //     path: '/postManagement/postBrand'
      //   })
      // })

      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          var param = JSON.parse(JSON.stringify(this.form.getFieldsValue()))
          param.icon = this.imgUp
          param.typeList = this.values
          if (this.$route.query.title === '编辑') {
            param.id = this.$route.query.id
          }
          saveBrand(param).then((res) => {
            this.$message.success(res.msg)
            this.$router.push({
              path: '/postManagement/postBrand'
            })
          })
        }
      })
    },
    back () {
      this.$router.go(-1)
    }

  }
}
</script>
<style scoped>
  .ant-calendar-picker {
    width:100%
  }
</style>
<style lang="stylus" scoped>
.card-title.subtitle
  font-size 14px
.upload-tip
  font-size 12px
  color #999999
  .tip-icon
    margin-right 6px
</style>
